export default __webpack_public_path__ + "static/media/me.b8daa2d5.jpg";